import {
  action
} from './common';

export const types = {
  COVERAGE_RESET: 'COVERAGE/RESET',

  COVERAGE_QUERY_REQUEST: 'COVERAGE/QUERY/REQUEST',
  COVERAGE_QUERY_SUCCESS: 'COVERAGE/QUERY/SUCCESS',
  COVERAGE_QUERY_FAILURE: 'COVERAGE/QUERY/FAILURE',

  COVERAGE_SHOW_REQUEST: 'COVERAGE/SHOW/REQUEST',
  COVERAGE_SHOW_SUCCESS: 'COVERAGE/SHOW/SUCCESS',
  COVERAGE_SHOW_FAILURE: 'COVERAGE/SHOW/FAILURE',
};

export const actions = {
  queryRequest: request => action(types.COVERAGE_QUERY_REQUEST, { request }),
  querySuccess: ({ customers = {}, total = 0 }) => action(types.COVERAGE_QUERY_SUCCESS, { customers, total }),
  queryFailure: error => action(types.COVERAGE_QUERY_FAILURE, { error }),

  showRequest: (request, id) => action(types.COVERAGE_SHOW_REQUEST, { request, id }),
  showSuccess: ({ customer, policies, claims }) => action(types.COVERAGE_SHOW_SUCCESS, { customer, policies, claims }),
  showFailure: error => action(types.COVERAGE_SHOW_FAILURE, { error }),
};

const initialState = {
  query: {
    request: {},
    total: 0,
    customers: {}
  },
  show: {
    request: {},
    customer: {},
    policies: {},
    claims: {},
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.COVERAGE_RESET:
      return {
        ...initialState
      };
    case types.COVERAGE_QUERY_REQUEST:
      return {
        ...state,
        query: {
          ...state.query,
          request: {
            ...action.request
          }
        },
        show: {
          ...initialState.show
        }
      };
    case types.COVERAGE_QUERY_SUCCESS:
      return {
        ...state,
        query: {
          ...state.query,
          total: action.total,
          customers: {
            ...action.customers
          }
        }
      };
    case types.COVERAGE_QUERY_FAILURE:
      return state;
    case types.COVERAGE_SHOW_REQUEST:
      return {
        ...state,
        show: {
          ...state.show,
          request: {
            ...action.request,
            id: action.id
          }
        }
      };
    case types.COVERAGE_SHOW_SUCCESS:
      return {
        ...state,
        show: {
          ...state.show,
          customer: {
            ...action.customer
          },
          policies: {
            ...action.policies,
          },
          claims: {
            ...action.claims,
          }
        }
      };
    case types.COVERAGE_SHOW_FAILURE:
      return state;
    default:
      return state;
  }
}

export const getTotal = state => state.query.total;
export const getCustomers = state => state.query.customers;
export const getCustomer = state => state.show.customer;
export const getPolicies = state => state.show.policies;
export const getClaims = state => state.show.claims;



// WEBPACK FOOTER //
// ./src/reducers/coverage.js